// App Redux store. Every page's data layer is a slice under `./slices` (one slice
// file per page — the single home for API-backed state; each slice owns its
// `createAsyncThunk` calls). Adding a page = one slice file in store/slices + one
// reducer key here.
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth.slice';
import notificationsReducer from './slices/notifications.slice';
import dashboardReducer from './slices/dashboard.slice';
import portfolioReducer from './slices/portfolio.slice';
import manageAccountReducer from './slices/manageAccount.slice';
import planBrandingReducer from './slices/planBranding.slice';
import sponsorReducer from './slices/sponsor.slice';

export const store = configureStore({
  reducer: {
    auth: authReducer, // app-global identity + selected account (the multi-plan seam)
    notifications: notificationsReducer, // header bell's all-plan (global) feed
    dashboard: dashboardReducer,
    portfolio: portfolioReducer,
    manageAccount: manageAccountReducer,
    planBranding: planBrandingReducer, // header plan logo branding (/plans/{planId})
    sponsor: sponsorReducer, // plan-sponsor persona: plan picker + plan dashboard
  },
});

export default store;
